import { authContext, endpoint } from './AdalConfig'

export default class AuthService {
    authenticateToken = () => {
        if (authContext.getCachedUser()) {
            return true
        }
        if (authContext.isCallback(window.location.hash)) {
            authContext.handleWindowCallback()
            return true
        }
        return false
    }

    login() {
        authContext.login()
    }

    loggedIn() {
        return this.getUser() ? true : false
    }

    logout() {
        authContext.logOut()
    }

    getToken() {
        return authContext.getCachedToken(endpoint)
    }

    getUser() {
        return authContext.getCachedUser()
    }
}
